import { render, staticRenderFns } from "./appContent.vue?vue&type=template&id=8bf52c58&scoped=true"
import script from "./appContent.vue?vue&type=script&lang=js"
export * from "./appContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf52c58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8bf52c58')) {
      api.createRecord('8bf52c58', component.options)
    } else {
      api.reload('8bf52c58', component.options)
    }
    module.hot.accept("./appContent.vue?vue&type=template&id=8bf52c58&scoped=true", function () {
      api.rerender('8bf52c58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemAdministrator/creatApp/appContent.vue"
export default component.exports